import React from "react";
import { useState, useEffect, useContext } from "react";
import Edit from "./Edit";
import { Spinner } from "react-bootstrap";
import Languages from "./languages/Languages";
import Educations from "./education/Educations";
import Courses from "./courses/Courses";
import Experience from "./experience/Experience";
import Relatives from "./relatives/Relatives";
import Recommends from "./recommends/Recommends";
import Documents from "./documents/Documents";
import Emails from "./emails/Emails";
import Evaluation from "./Evaluation";
import MoamadootNotes from "./moamadootnotes/MoamadootNotes";
import {
  useParams,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import AuditModal from "../shared/AuditModal";
import AuditContext from "../shared/context/AuditProvider";
import { ImForward } from "react-icons/im";

const baseURL = process.env.REACT_APP_API_JOBS;
const baseURLAuth = process.env.REACT_APP_API;

const MoamadAdmin = (props) => {
  //const { moamad_id, user_id, mekhraz_title, is_disabled_doc } = useParams();
  const { state } = useLocation();

  const { showAudit, setShowAudit, model, setModel, srcId, setSrcId } =
    useContext(AuditContext);

  const [page, setPage] = useState(1);
  const [moamad, setMoamad] = useState({});
  const [newM, setNewM] = useState({});
  const [user, setUser] = useState({});
  const [counter, setCounter] = useState(0);
  const [loading, setLoading] = useState(true);
  let location = useLocation();
  //let user_id = 0;
  let m = {};
  let navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate("application/json");
  const [dynamicPadding, setDynamicPadding] = useState(0);
  const moamad_id = state?.moamad_id;
  const user_id = state?.user_id;
  const mekhraz_title = state?.mekhraz_title;
  const is_disabled_doc = state?.is_disabled_doc;

  //const { moamad_id, user_id, mekhraz_title, is_disabled_doc } = state;
  useEffect(() => {
    // Update dynamicPadding when the window is resized
    const handleResize = () => {
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;
      const calculatedPadding = windowHeight * 0.2; // Adjust the multiplier as needed
      setDynamicPadding(calculatedPadding);
    };

    // Initial setup
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  /*
  useEffect(() => {
    const getUser = async () => {
      try {
        const response2 = await axiosPrivate
          .get(baseURLAuth + "accounts/getuser/" + user_id)
          .then((response2) => {
            setUser(response2.data);
          });
      } catch (err) {
        console.log(err);
      }
    };
    getUser();
  }, []);
  */
  useEffect(() => {
    if (!user_id) return;

    const getUser = async () => {
      try {
        const response2 = await axiosPrivate.get(
          baseURLAuth + "accounts/getuser/" + user_id,
        );
        setUser(response2.data);
      } catch (err) {
        console.log(err);
      }
    };
    getUser();
  }, [user_id]);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "moamad/" + moamad_id,
          {
            signal: controller.signal,
          },
        );
        if (isMounted) {
          setMoamad(response.data);
          setNewM(response.data);
          setSrcId(response.data.id);
          setModel("Moamad");
          //user_id = response.data.user;

          // Now call getData2() after getting the response
          //await getData2();
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            "The client never received a response, and the request was never left",
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert("Anything else");
        }
      }
    };

    getData();

    setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => {
      controller.abort();
    };
  }, [counter]);
  if (!state) return <Navigate to="/" replace />;
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <>
        {showAudit && <AuditModal />}
        <nav
          className="navbar navbar-expand-md bg-dark navbar-dark fixed-right "
          style={{
            //paddingTop: `calc( ${dynamicPadding}px)`,
            height: "calc(100vh - 0px)",
            overflowY: "scroll",
          }}
        >
          <h6
            onClick={() => {
              setShowAudit(true);
            }}
            className="navbar-brand mb-0 h6 text-center"
            style={{ whiteSpace: "pre-line" }}
          >
            ניהול מועמד
            <br />({mekhraz_title})
          </h6>

          <ul className="navbar-nav flex-column ml-auto">
            <li className="nav-item">
              <button
                className="btn btn-primary navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => navigate(-1)}
              >
                <ImForward />
                חזרה
              </button>
            </li>
            <li className="nav-item active">
              <button
                className="btn btn-success navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(1)}
              >
                פרטים
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-success navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(2)}
              >
                <span
                  style={{ color: "#FFFF00", fontSize: 16, fontWeight: "bold" }}
                >
                  {moamad?.language_moamad?.length}
                </span>
                -שפות
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-success navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(3)}
              >
                <span
                  style={{ color: "#FFFF00", fontSize: 16, fontWeight: "bold" }}
                >
                  {moamad?.education_moamad?.length}
                </span>
                -השכלה
              </button>
            </li>
            <li>
              <button
                className="btn btn-success navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(4)}
              >
                <span
                  style={{ color: "#FFFF00", fontSize: 16, fontWeight: "bold" }}
                >
                  {moamad?.course_moamad?.length}
                </span>
                -קורסים והשתלמיות{" "}
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-success navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(5)}
              >
                <span
                  style={{ color: "#FFFF00", fontSize: 16, fontWeight: "bold" }}
                >
                  {moamad?.workexperience_moamad?.length}
                </span>
                -ניסיון תעסוקתי
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-success navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(6)}
              >
                <span
                  style={{ color: "#FFFF00", fontSize: 16, fontWeight: "bold" }}
                >
                  {moamad?.recommend_moamad?.length}
                </span>
                -ממליצים
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-success navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(7)}
              >
                <span
                  style={{ color: "#FFFF00", fontSize: 16, fontWeight: "bold" }}
                >
                  {moamad?.relative_moamad?.length}
                </span>
                -קירבה
              </button>
            </li>
            <li className="nav-item">
              <button
                disabled={is_disabled_doc}
                className="btn btn-success navbar-btn md-button"
                style={{ color: "white" }}
                onClick={() => setPage(8)}
              >
                <span
                  style={{ color: "#FFFF00", fontSize: 16, fontWeight: "bold" }}
                >
                  {moamad?.moamaddocument_moamad?.length}
                </span>
                -מסמכים
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-success navbar-btn md-button"
                style={{ marginLeft: "10px", color: "white" }}
                onClick={() => {
                  setPage(9);
                }}
              >
                הערכה
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-success navbar-btn md-button"
                style={{ marginLeft: "10px", color: "#FFFFFF" }}
                onClick={() => {
                  setPage(10);
                }}
              >
                דואר אלקטרוני
              </button>
            </li>
            <li className="nav-item">
              <button
                className="btn btn-success navbar-btn md-button"
                style={{ marginLeft: "10px", color: "#FFFFFF" }}
                onClick={() => {
                  setPage(11);
                }}
              >
                תיעוד
              </button>
            </li>
          </ul>
        </nav>
        <div style={{ paddingRight: "90px" }}>
          {page === 1 && (
            <Edit
              visible={page == 1}
              newM={newM}
              setNewM={setNewM}
              moamad={moamad}
              setMoamad={setMoamad}
              uEmail={user.email}
            />
          )}
          {page === 2 && (
            <Languages
              visible={page == 2}
              moamad={moamad}
              counter={counter}
              setCounter={setCounter}
            />
          )}
          {page === 3 && (
            <Educations
              visible={page == 3}
              moamad={moamad}
              counter={counter}
              setCounter={setCounter}
            />
          )}
          {page === 4 && (
            <Courses
              visible={page == 4}
              moamad={moamad}
              counter={counter}
              setCounter={setCounter}
            />
          )}
          {page === 5 && (
            <Experience
              visible={page == 5}
              moamad={moamad}
              counter={counter}
              setCounter={setCounter}
            />
          )}
          {page === 6 && (
            <Recommends
              visible={page == 6}
              moamad={moamad}
              counter={counter}
              setCounter={setCounter}
            />
          )}
          {page === 7 && (
            <Relatives
              visible={page == 7}
              moamad={moamad}
              counter={counter}
              setCounter={setCounter}
            />
          )}
          {page === 8 && (
            <Documents
              visible={page == 8}
              moamad={moamad}
              counter={counter}
              setCounter={setCounter}
            />
          )}
          {page === 9 && (
            <Evaluation
              visible={page == 9}
              newM={newM}
              setNewM={setNewM}
              moamad={moamad}
              setMoamad={setMoamad}
              uEmail={user.email}
            />
          )}
          {page === 11 && (
            <MoamadootNotes
              visible={page == 11}
              moamad={moamad}
              counter={counter}
              setCounter={setCounter}
            />
          )}
          {page === 10 && <Emails visible={page == 10} moamad={moamad} />}
        </div>
      </>
    );
  }
};

export default MoamadAdmin;
